import styled from 'styled-components'

import { mq, sizes } from '../../../theme'
import _Step from '../Step'

export const Container = styled.div<{ $backgroundColor?: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.6rem;
  margin-bottom: 2rem;
`

export const StepNumber = styled.div`
  ${({ theme }) => theme.textStyles.text_bold_32}
  color: ${({ theme }) => theme.colors.familyBurgundy};
  text-align: right;
  background-color: ${({ theme }) => theme.colors.familyYellow};
  border-radius: 50%;
  padding: 0.5rem 1.7rem;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_50}
    padding: 1rem 3rem;
  }
`

export const Step = styled(_Step)``
